
  import * as storyblokRuntime$KzQxBFOuxpYL2GUyMl8mmph57iBhpBASitHyrNzpE_45s from '/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/node_modules/.pnpm/@nuxt+image@1.11.0_@netlify+blobs@9.1.2_db0@0.3.2_ioredis@5.7.0_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/storyblok'
import * as ipxRuntime$dfjr_s1Xq5C1Bj0xbZK3plIP_h0AzL_m4j9zWe4D9Fo from '/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/node_modules/.pnpm/@nuxt+image@1.11.0_@netlify+blobs@9.1.2_db0@0.3.2_ioredis@5.7.0_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/ipx'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    providers: {
        ['storyblok']: { provider: storyblokRuntime$KzQxBFOuxpYL2GUyMl8mmph57iBhpBASitHyrNzpE_45s, defaults: {"baseURL":"https://a.storyblok.com"} },
  ['ipx']: { provider: ipxRuntime$dfjr_s1Xq5C1Bj0xbZK3plIP_h0AzL_m4j9zWe4D9Fo, defaults: {} }
    }
  }
